import React from "react";
import { Container } from "react-bootstrap";
import cover_img11 from "../../assets/news_cover11.png";

function News11() {
  return (
    <Container>
      <br />
      <img
        src={cover_img11}
        style={{ width: "15%", float: "right", marginLeft: "1rem" }}
      />
      <p style={{ color: "grey", fontSize: "1.5rem", margin: "2rem" }}>
        October 30, 2025
      </p>
      <br />
      <h2
        style={{ color: "#003561", marginBottom: "1rem", marginLeft: "2rem" }}
      >
        AMPERE AND STRATUS MATERIALS SIGN A JOINT DEVELOPMENT AGREEMENT TO
        EXPLORE THE APPLICATION OF COBALT-FREE CATHODE TECHNOLOGY FOR RENAULT
        GROUP’S NEXT-GENERATION ELECTRIC VEHICLES
      </h2>

      <ul
        style={{
          color: "grey",
          fontSize: "1.5rem",
          margin: "2rem",
          paddingLeft: "3rem",
        }}
      >
        <li style={{ marginBottom: "0.5rem" }}>
          Ampere partners with Stratus Materials in a Joint Development
          Agreement (JDA) to explore innovative cobalt-free LXMO<sup>TM</sup>{" "}
          battery technology for future Renault Group EVs.
        </li>
        <li>
          LXMO<sup>TM</sup> technology offers high energy density comparable to
          NMC batteries, with cost and abuse tolerance similar to LFP batteries.
        </li>
        <li>
          This collaboration is part of Ampere's strategy to develop
          next-generation batteries, following NMC and LFP technologies
        </li>
      </ul>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <b>
          Boulogne-Billancourt (France), Pittsburgh, PA (US) – October 30, 2025
        </b>{" "}
        -{" "}
        <a
          href="https://www.ampere.cars/en"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ampere
        </a>{" "}
        , the EV and Software pure player from Renault Group has entered into a
        Joint Development Agreement (JDA) with{" "}
        <a
          href="https://www.stratusmaterials.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stratus Materials Inc.
        </a>{" "}
        , a leading developer of high energy cobalt-free LXMO<sup>TM</sup>{" "}
        cathode active materials (CAM) for advanced Li-Ion batteries. This JDA
        represents the first step to evaluate the relevance of inserting Stratus
        Material’s high energy cobalt-free LXMO<sup>TM</sup> into the Renault
        Group’s electric vehicle (EV) fleet and focuses on demonstrating the
        high performance of the material in EV-format battery cells. This new
        technology developed by Stratus Materials will be tested in Ampere’s
        Battery Cell Innovation Lab recently inaugurated in Lardy, France,
        and designed to anticipate technological breakthroughs and strengthen
        Renault Group’s competiveness in the electric vehicle sector.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        LXMO<sup>TM</sup> - based batteries present a highly attractive
        potential solution for EVs because they can deliver high energy
        densities comparable to or better than those using NMC, but with low
        cost and abuse tolerance similar to those using LFP. At the systems
        level, the combination of improved abuse tolerance with high energy
        density results in pack-level energy densities that are up to twice that
        of either NMC- or LFP-based battery packs. This results in significant
        design and economic advantages to Ampere, with the promise of lower cost
        vehicles with longer range and better safety.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Cobalt-free technology is the third step of Ampere’s battery strategy,
        after NMC for its high density, and LFP which will enter Renault’s cars
        in 2026.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <i>
          “Ampere is looking closely at high energy cobalt-free materials
          because of their potential advantages compared to incumbent cathode
          materials. Stratus's LXMO<sup>TM</sup> CAMs have gained Ampere’s
          attention because of their unique and compelling combination of
          performance, cost, safety, and cycle life.”
        </i>{" "}
        Nicolas Racquet, VP Vehicle & Powertrain Engineering, Ampere.
      </p>
      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Jay Whitacre, the CEO of Stratus, commented,{" "}
        <i>
          “We are thrilled to have LXMO<sup>TM</sup> selected by Ampere and
          Renault Group as a candidate for deployment into their future vehicle
          portfolio. Our progress to date with Ampere has been strong and we
          look forward to delivering on the ongoing JDA and moving together
          toward full vehicle deployments.”
        </i>
      </p>
      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Given the critical importance of advanced battery materials, cells, and
        packs in today’s electric vehicles, this announcement is another example
        of how Ampere is positioning itself as a leader in the EV technology
        space by embracing innovative solutions that can offer substantial
        technological improvements with reduced environmental impact and supply
        chain complexity.
      </p>
      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <i>
          LXMO<sup>TM</sup> = Lithium X Manganese Oxide
        </i>
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <strong>About Stratus Materials</strong>
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <a
          href="https://www.stratusmaterials.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stratus Materials
        </a>{" "}
        is a U.S- based company focused on the development and commercialization
        of next-generation LXMO<sup>TM</sup> cathode active materials for
        lithium-ion batteries. Our mission is to disrupt the CAM supply chain by
        offering materials with a game-changing combination of performance,
        safety, and cost. Stratus’s business model is licensing partnerships,
        where Stratus teams with large, existing CAM producers or users to
        produce and sell LXMO<sup>TM</sup> into the lithium-ion battery
        industry.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <b>Media Contact</b> Robyn Kennedy – Marketing Lead{" "}
        <a href="mailto:marketing@stratusmaterials.com">
          marketing@stratusmaterials.com
        </a>
      </p>

      <br />

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <strong>About Ampere</strong>
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Ampere is the first European intelligent EV pure player. Born from
        Renault Group, Ampere designs, develops and manufactures full electric
        vehicles featuring cutting-edge software technology, accessible to all.
        Customer experience, as well as social and environmental impact, are
        embedded throughout the vehicle development process to ensure they align
        with the brand’s commitment to its customers, the planet and those
        living on it. For more information, please visit{" "}
        <a
          href="https://www.ampere.cars/en"
          target="_blank"
          rel="noopener noreferrer"
        >
          ampere.cars
        </a>{" "}
        or follow Ampere on{" "}
        <a
          href="https://www.linkedin.com/company/amperecars/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>{" "}
        and{" "}
        <a
          href="https://twitter.com/ampere"
          target="_blank"
          rel="noopener noreferrer"
        >
          X
        </a>{" "}
        .
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <b>Contact</b> Samira Chakkaf – Head of External Communication –{" "}
        <a href="mailto:samira.chakkaf@ampere.cars">
          samira.chakkaf@ampere.cars
        </a>{" "}
        – +33 6.76.86.01.46
      </p>
      <a
        style={{
          fontSize: "1.5rem",
          margin: "2rem",
          textDecoration: "None",
          display: "flex",
          justifyContent: "center",
        }}
        href="/news"
      >
        <strong style={{ textAlign: "center" }}>BACK TO NEWS</strong>
      </a>
      <br />
      <br />
    </Container>
  );
}

export default News11;
